<template>
  <div>
    <div class="wrapper" ref="scroll_content">
      <header>
        <section class="header__container">
          <div class="header__button--compare" :class="{active: is_compare}">
            <input type="radio" id="calListDefault" name="calList" checked>
            <label class="" for="calListDefault" @click="is_compare = false">
              <img class="compare-on" src="img/icon/hdicn_cal_default_on.png">
              <img class="compare-off" src="img/icon/hdicn_cal_default_off.png">
            </label>
            <input type="radio" id="calListCompare" name="calList">
            <label class="" for="calListCompare" @click="is_compare = true">
              <img class="compare-off" src="img/icon/hdicn_cal_compare_on.png">
              <img class="compare-on" src="img/icon/hdicn_cal_compare_off.png">
            </label>
          </div>
          <div class="header__buttonset--right">
            <div class="header__input--search">
              <input type="text" placeholder="絞り込み検索"  v-model="search_text" @keydown.enter="search">
            </div>
            <div class="header__button--setting" @click="toggleSetting">
              <img src="img/icon/hdicn_setting.png">
            </div>
          </div>
        </section>
        <div class="setting__background" @click.self="closeSetting">
          <section class="setting">
            <div class="setting__balloon">
              <div v-for="(item, index) in groupData" :key="index">
                <input type="radio" name="group" :id="'group' + index" v-model="trn_group_id" :value="item.trn_group_id" :checked="item.trn_group_id === trn_group_id">
                <label class="setting__group" :for="'group' + index">
                  <p class="setting__group--name">{{ item.group_name }}</p>
                  <div class="setting__group--info">
                    <p v-if="item.is_owner">管理者として参加中</p>
                    <p v-else></p>
                    <p>{{ item.limit_datetime.split(' ')[0] }}まで</p>
                  </div>
                </label>
              </div>
              <a class="setting__balloon--logout" @click="logout">ログアウト</a>
            </div>
          </section>
        </div>
      </header>
      <!--calendar ひと月単位-->
      <section class="calendar" :class="{'compare': is_compare}">
        <!--calendar__wrapper 比較用-->
        <section class="calendar__wrapper">
          <div v-if="calendarSearchData === null" class="calendar__header" :class="{'compare-header': is_compare}">
            <div class="calendar__heading">
              <div>
                <select v-model="header_select" @change="getSelectCalendar">
                  <option v-for="(item) in calendar_data_keys" :key="item" :value="item">{{ CALENDAR_DATE[item] }}</option>
                </select>
              </div>
            </div>
            <table class="header__table">
              <tr class="calendar__item">
                <th></th>
                <th>病害虫</th>
                <th>メモ</th>
                <th colspan="2">作業記録・投稿</th>
              </tr>
            </table>
          </div>
          <template v-if="calendarSearchData === null">
            <table class="calendar__container">
              <tr v-if="!is_compare" class="calendar__item" style="height: 0">
                <th></th>
                <th></th>
                <th></th>
                <th colspan="2"></th>
              </tr>
              <tr v-for="(item, index) in month_data" :key="index" class="calendar__daily" :id="index">
                <td class="date__content" :data-year="item.year" :data-month="item.month">
                  <p :class="{day__sat: item.holidayFlg === 1 , day__sun: item.holidayFlg === 2 || item.holidayFlg === 3 || item.holidayFlg === 4}">
                    {{ item.day }}日 ({{ item.dayOfWeek }})
                  </p>
                  <div v-if="weather_data[index] !== null && weather_data[index] !== undefined"
                     class="calendar__daily--temp">
                    <img :src="'https://openweathermap.org/img/wn/' + weather_data[index].weather_name + '.png'">
                    <span v-if="weather_data[index].temp_max !== null"
                          class="temp__high">{{ parseInt(weather_data[index].temp_max) }}℃</span>
                    <span v-else>-</span>
                    /
                    <span v-if="weather_data[index].temp_min !== null"
                          class="temp__low">{{ parseInt(weather_data[index].temp_min) }}℃</span>
                    <span v-else>-</span>
                  </div>
                  <p v-else class="calendar__daily--temp">
                    - / -
                  </p>
                  <a v-if="item.lastDay" class="last--day"></a>
                </td>
                <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.sick, item)">
                  <template v-if="item.data.sick_data !== null">
                    <img v-if="item.data.sick_data.image_url !== null" :src="item.data.sick_data.image_url">
                    <p>{{ item.data.sick_data.title }}</p>
                    <p>{{ item.data.sick_data.comment }}</p>
                    <span v-if="item.data.sick_data.count > 0">その他　{{ item.data.sick_data.count }}件</span>
                  </template>
                </td>
                <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.memo, item)">
                  <template v-if="item.data.memo_data !== null">
                    <p>{{ item.data.memo_data.comment }}</p>
                    <span v-if="item.data.memo_data.count > 0">その他　{{ item.data.memo_data.count }}件</span>
                  </template>
                </td>
                <template v-if="item.data.post_data !== null && item.data.post_data.length !== 0">
                  <td v-for="(post, post_index) in item.data.post_data" :key="post_index" @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)">
                    <img v-if="post.image_url !== null" :src="post.image_url">
                    <p>{{ post.comment }}</p>
                    <span v-if="post_index === 1 && item.post_other_count > 0">その他　{{ item.post_other_count }}件</span>
                  </td>
                  <td v-if="item.data.post_data.length < 2" @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                </template>
                <template v-else-if="item.data.post_data === null || item.data.post_data.length === 0">
                  <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                  <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                </template>
              </tr>
            </table>
          </template>
          <template v-else>
            <div v-for="(search_data, date) in search_month_data" :key="date">
              <div class="calendar__heading">
                {{ date.split('-')[0] }}年{{ date.split('-')[1] }}月
              </div>
              <table class="header__table">
                <tr class="calendar__item">
                  <th></th>
                  <th>病害虫</th>
                  <th>メモ</th>
                  <th colspan="2">作業記録・投稿</th>
                </tr>
              </table>
              <table class="calendar__container" style="margin-top: -10px;">
                <tr class="calendar__item" style="height: 10px;">
                  <th style="border-top: none"></th>
                  <th style="border-top: none"></th>
                  <th style="border-top: none"></th>
                  <th colspan="2" style="border-top: none"></th>
                </tr>
                <tr v-for="(item, index) in search_data" :key="index" class="calendar__daily">
                  <td>
                    <p v-if="item.month !== null" :class="{day__sat: item.holidayFlg === 1 , day__sun: item.holidayFlg === 2 || item.holidayFlg === 3 || item.holidayFlg === 4}">
                      {{ item.day }}日 ({{ item.dayOfWeek }})
                    </p>
                    <div v-if="search_weather_data[index] !== null && search_weather_data[index] !== undefined"
                       class="calendar__daily--temp">
                      <img :src="'https://openweathermap.org/img/wn/' + weather_data[index].weather_name + '.png'">
                      <span v-if="search_weather_data[index].temp_max !== null"
                            class="temp__high">{{ parseInt(search_weather_data[index].temp_max) }}℃</span>
                      <span v-else>-</span>
                      /
                      <span v-if="search_weather_data[index].temp_min !== null"
                            class="temp__low">{{ parseInt(search_weather_data[index].temp_min) }}℃</span>
                      <span v-else>-</span>
                    </div>
                    <p v-else-if="item.month !== null" class="calendar__daily--temp">
                      - / -
                    </p>
                  </td>
                  <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.sick, item)">
                    <template v-if="item.data.sick_data !== null">
                      <img v-if="item.data.sick_data.image_url !== null" :src="item.data.sick_data.image_url">
                      <p>{{ item.data.sick_data.title }}</p>
                      <p>{{ item.data.sick_data.comment }}</p>
                      <span v-if="item.data.sick_data.count > 0">その他　{{ item.data.sick_data.count }}件</span>
                    </template>
                  </td>
                  <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.memo, item)">
                    <template v-if="item.data.memo_data !== null">
                      <p>{{ item.data.memo_data.comment }}</p>
                      <span v-if="item.data.memo_data.count > 0">その他　{{ item.data.memo_data.count }}件</span>
                    </template>
                  </td>
                  <template v-if="item.data.post_data !== null && item.data.post_data.length !== 0">
                    <td v-for="(post, post_index) in item.data.post_data" :key="post_index" @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)">
                      <img v-if="post.image_url !== null" :src="post.image_url">
                      <p>{{ post.comment }}</p>
                      <span v-if="post_index === 1 && item.post_other_count > 0">その他　{{ item.post_other_count }}件</span>
                    </td>
                    <td v-if="item.data.post_data.length < 2" @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                  </template>
                  <template v-else-if="item.data.post_data === null || item.data.post_data.length === 0">
                    <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                    <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                  </template>
                </tr>
              </table>
            </div>
          </template>
        </section>
        <!--/calendar__wrapper-->
        <!--calendar__wrapper.prev 比較用前年度-->
        <section class="calendar__wrapper prev">
          <div v-if="calendarSearchData === null" class="calendar__header">
            <div class="calendar__heading">
              <div>
                <select v-model="header_compare_select" @change="changeCompareSub(header_compare_select)">
                  <option v-for="(item) in header_select.split('-')[0] - START_YEAR" :key="START_YEAR + (item - 1)" :value="START_YEAR + (item - 1)">{{ START_YEAR + (item - 1) }}</option>
                </select>
              </div>
              <span class="ml-1">{{ header_month }}月</span>
            </div>
            <table class="header__table">
              <tr class="calendar__item">
                <th></th>
                <th>病害虫</th>
                <th>メモ</th>
                <th colspan="2">作業記録・投稿</th>
              </tr>
            </table>
          </div>
          <template v-if="calendarSearchData === null">
            <table class="calendar__container">
              <tr v-for="(item, index) in compare_month_data" :key="index" class="calendar__daily">
                <td>
                  <p :class="{day__sat: item.holidayFlg === 1 , day__sun: item.holidayFlg === 2 || item.holidayFlg === 3 || item.holidayFlg === 4}">
                    {{ item.day }}日 ({{ item.dayOfWeek }})
                  </p>
                  <div v-if="prev_weather_data[index] !== null && weather_data[index] !== undefined"
                     class="calendar__daily--temp">
                    <img :src="'https://openweathermap.org/img/wn/' + prev_weather_data[index].weather_name + '.png'">
                    <span v-if="weather_data[index].temp_max !== null"
                          class="temp__high">{{ parseInt(weather_data[index].temp_max) }}℃</span>
                    <span v-else>-</span>
                    /
                    <span v-if="weather_data[index].temp_min !== null"
                          class="temp__low">{{ parseInt(weather_data[index].temp_min) }}℃</span>
                    <span v-else>-</span>
                  </div>
                  <p v-else class="calendar__daily--temp">
                    - / -
                  </p>
                </td>
                <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.sick, item)">
                  <template v-if="item.data.sick_data !== null">
                    <img v-if="item.data.sick_data.image_url !== null" :src="item.data.sick_data.image_url">
                    <p>{{ item.data.sick_data.title }}</p>
                    <p>{{ item.data.sick_data.comment }}</p>
                    <span v-if="item.data.sick_data.count > 0">その他　{{ item.data.sick_data.count }}件</span>
                  </template>
                </td>
                <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.memo, item)">
                  <template v-if="item.data.memo_data !== null">
                    <p>{{ item.data.memo_data.comment }}</p>
                    <span v-if="item.data.memo_data.count > 0">その他　{{ item.data.memo_data.count }}件</span>
                  </template>
                </td>
                <template v-if="item.data.post_data !== null && item.data.post_data.length !== 0">
                  <td v-for="(post, post_index) in item.data.post_data" :key="post_index" @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)">
                    <img v-if="post.image_url !== null" :src="post.image_url">
                    <p>{{ post.comment }}</p>
                    <span v-if="post_index === 1 && item.post_other_count > 0">その他　{{ item.post_other_count }}件</span>
                  </td>
                  <td v-if="item.data.post_data.length < 2" @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                </template>
                <template v-else-if="item.data.post_data === null || item.data.post_data.length === 0">
                  <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                  <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                </template>
              </tr>
            </table>
          </template>
          <template v-else>
            <div v-for="(search_data, date) in search_compare_month_data" :key="date">
              <div class="calendar__heading">
                {{ parseInt(date.split('-')[0]) }}年{{ date.split('-')[1] }}月
              </div>
              <table class="header__table">
                <tr class="calendar__item">
                  <th></th>
                  <th>病害虫</th>
                  <th>メモ</th>
                  <th colspan="2">作業記録・投稿</th>
                </tr>
              </table>
              <table class="calendar__container" style="margin-top: -10px;">
                <tr class="calendar__item" style="height: 10px;">
                  <th style="border-top: none"></th>
                  <th style="border-top: none"></th>
                  <th style="border-top: none"></th>
                  <th colspan="2" style="border-top: none"></th>
                </tr>
                <tr v-for="(item, index) in search_data" :key="index" class="calendar__daily">
                  <td>
                    <p v-if="item.month !== null" :class="{day__sat: item.holidayFlg === 1 , day__sun: item.holidayFlg === 2 || item.holidayFlg === 3 || item.holidayFlg === 4}">
                      {{ item.day }}日 ({{ item.dayOfWeek }})
                    </p>
                    <div v-if="search_compare_weather_data[index] !== null && search_compare_weather_data[index] !== undefined"
                       class="calendar__daily--temp">
                      <img :src="'https://openweathermap.org/img/wn/' + search_compare_weather_data[index].weather_name + '.png'">
                      <span v-if="search_compare_weather_data[index].temp_max !== null"
                            class="temp__high">{{ parseInt(search_compare_weather_data[index].temp_max) }}℃</span>
                      <span v-else>-</span>
                      /
                      <span v-if="search_compare_weather_data[index].temp_min !== null"
                            class="temp__low">{{ parseInt(search_compare_weather_data[index].temp_min) }}℃</span>
                      <span v-else>-</span>
                    </div>
                    <p v-else-if="item.month !== null" class="calendar__daily--temp">
                      - / -
                    </p>
                  </td>
                  <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.sick, item)">
                    <template v-if="item.data.sick_data !== null">
                      <img v-if="item.data.sick_data.image_url !== null" :src="item.data.sick_data.image_url">
                      <p>{{ item.data.sick_data.title }}</p>
                      <p>{{ item.data.sick_data.comment }}</p>
                      <span v-if="item.data.sick_data.count > 0">その他　{{ item.data.sick_data.count }}件</span>
                    </template>
                  </td>
                  <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.memo, item)">
                    <template v-if="item.data.memo_data !== null">
                      <p>{{ item.data.memo_data.comment }}</p>
                      <span v-if="item.data.memo_data.count > 0">その他　{{ item.data.memo_data.count }}件</span>
                    </template>
                  </td>
                  <template v-if="item.data.post_data !== null && item.data.post_data.length !== 0">
                    <td v-for="(post, post_index) in item.data.post_data" :key="post_index" @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)">
                      <img v-if="post.image_url !== null" :src="post.image_url">
                      <p>{{ post.comment }}</p>
                      <span v-if="post_index === 1 && item.post_other_count > 0">その他　{{ item.post_other_count }}件</span>
                    </td>
                    <td v-if="item.data.post_data.length < 2" @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                  </template>
                  <template v-else-if="item.data.post_data === null || item.data.post_data.length === 0">
                    <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                    <td @click="openDetailModal('modalCalendarDetail', TAB_TYPE.post, item)"></td>
                  </template>
                </tr>
              </table>
            </div>
          </template>
        </section>
        <!--/calendar__wrapper.prev-->
      </section>
      <!--/calendar-->
    </div>
    <!--/wrapper-->
    <!--modal-->
    <div class="modal" id="overlay" hidden>
      <!--カレンダー詳細ポップアップ-->
      <div class="modal__dflex" id="modalCalendarDetail" v-if="calendarDetailData !== null"
           @click.self="hide('modalCalendarDetail')">
        <div class="modal__wrapper modalarea">
          <section class="modal__header">
            <span>{{ modal_date }}</span>
            <nav class="cal-detail__tab">
              <input type="radio" name="calTab" id="calTab1" :value="TAB_TYPE.sick" v-model="modal_tab_type" checked>
              <input type="radio" name="calTab" id="calTab2" :value="TAB_TYPE.memo" v-model="modal_tab_type">
              <input type="radio" name="calTab" id="calTab3" :value="TAB_TYPE.post" v-model="modal_tab_type">
            </nav>
          </section>
          <!--病害虫-->
          <section class="modal__body" v-if="modal_tab_type === TAB_TYPE.sick">
            <article class="cal-detail" v-for="(item, index) in calendarDetailData.sick_list" :key="index">
              <div class="cal-detail__image">
                <img :src="item.image_url">
              </div>
              <ul class="cal-detail__list">
                <li class="cal-detail__title">
                  <p>{{ item.sick_name }}</p>
                </li>
                <li>
                  <p class="cal-detail__item">撮影時間</p>
                  <p class="cal-detail__detail">{{ item.datetime }}</p>
                </li>
                <li>
                  <p class="cal-detail__item">撮影場所</p>
                  <p class="cal-detail__detail">{{ item.location }}</p>
                </li>
                <li>
                  <p class="cal-detail__item">撮影者</p>
                  <p class="cal-detail__detail">{{ item.nickname }}</p>
                </li>
                <li>
                  <p class="cal-detail__item">メモ</p>
                  <p :id="'sick_' + index" class="cal-detail__detail" @click="editSick(index, item.is_self)">{{ item.comment }}</p>
                  <textarea :id="'sick_area_' + index" class="cal-detail__detail cancel-enter focus" @input="adjustHeight('#sick_area_' + index)" @blur="saveSick(index)" style="display: none;">{{ item.comment }}</textarea>
                </li>
              </ul>
            </article>
          </section>
          <!--病害虫ここまで-->
          <!--メモ-->
          <section class="modal__body" v-if="modal_tab_type === TAB_TYPE.memo">
            <button type="button" class="memo__button--add" @click="addMemo"></button>
            <article v-for="(item, index) in calendarDetailData.memo_list" :key="index" :id="'memo_content_' + index" class="memo">
              <div class="memo__auther">
                投稿者：{{ item.nickname }}
              </div>
              <div @click="openMemo(index, item.is_self)">
                <div :id="'memo_' + index" class="memo__content">{{ item.information }}</div>
                <textarea :id="'memo_area_' + index" class="memo__content focus" @input="adjustHeight('#memo_area_' + index)" @blur="saveMemo(index, item)" style="display: none;">{{ item.information }}</textarea>
              </div>
            </article>
          </section>

          <!--メモここまで-->
          <!--作業記録-->
          <section class="modal__body" v-if="modal_tab_type === TAB_TYPE.post">
            <article class="post" v-for="(item, index) in calendarDetailData.post_list" :key="index">
              <div class="post__name">
                <img :src="item.icon_url" class="toukou__icon--user">
                <p class="toukou__name--user" style="color: #01311F;">
                  {{ item.nickname }}
                </p>
                <img :src="ICON_LIST[item.user_type]" class="post__image--category">
              </div>
              <div v-if="item.image_url !== null" class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="toukou__image--view">
                      <img class="toukou__image--photo" :src="item.image_url">
                    </div>
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
              <div class="toukou__info">
                <span class="toukou__text--gray">
                  {{ item.datetime }}
                </span>
              </div>
              <div :id="'post_' + index" class="toukou__text" @click="editPost(index, item.is_self)">{{ item.information }}</div>
              <textarea :id="'post_area_' + index" class="toukou__text focus" @input="adjustHeight('#post_area_' + index)" @blur="savePost(index)" style="display: none;">{{ item.information }}</textarea>
              <div v-if="item.location !== ''" class="toukou__text--location">撮影場所： {{ item.location }}</div>
            </article>
          </section>
          <!--作業記録ここまで-->
        </div>
      </div>
      <!--/予定を入力-->
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import $ from 'jquery'
import {getHoliday, getCalendarDate} from '@/calendarUtil'
import {ICON_LIST} from "@/category";
import {USER_LOGIN} from "@/store/error";

export default {
  data() {
    return {
      START_YEAR: 1970,
      LAST_YEAR: 2059,
      ICON_LIST: ICON_LIST,
      CALENDAR_DATE: [],
      SCROLL_DEFAULT_POS: 7,
      calendar_data_keys: [],
      TAB_TYPE: {
        sick: 0,
        memo: 1,
        post: 2,
      },
      trn_group_id: "",
      old_group_id: "",
      nickname: "",
      current_year: 0,
      current_month: 0,
      next_year: 0,
      next_month: 0,
      prev_year: 0,
      prev_month: 0,
      weeks: ["日", "月", "火", "水", "木", "金", "土"],
      month_data: [],
      compare_month_data: [],
      modal_tab_type: 0,
      modal_date: "",
      header_month: "",
      weather_data: [],
      prev_weather_data: [],
      picture_datetime: "",
      update_month_data_key: "",
      search_param: {
        trn_group_id: 0,
        year: 0,
        search_words: "",
      },
      search_text: "",
      search_month_data: [],
      search_weather_data: [],
      search_compare_month_data: [],
      search_compare_weather_data: [],
      search_prev_year: 0,
      scroll_height: 0,
      is_compare: false,

      observer: null,
      observer_option: {
        root: null,
        rootMargin: "-30% 0px -70% 0px",
        threshold: 0
      },
      today: "",
      is_first: false,

      header_select: "",
      header_compare_select: "",
      header_compare_year_sub: 1,
    }
  },
  created() {
    if (this.groupData === null) {
      this.getGroup()
    }
    NativeStorage.getItem('group_id', value => this.initialize(value), () => {
      if (this.groupId !== null) {
        this.initialize(this.groupId)
      }
      else {
        this.$router.push('/')
      }
    })
    NativeStorage.getItem('profile', (value) => {
      this.nickname = value.nickname
    })
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.scroll_content !== undefined) {
        const content = this.$refs.scroll_content
        content.addEventListener('scroll', () => {
          if (content.scrollHeight <= content.scrollTop + content.offsetHeight) {
            if (this.calendarSearchData !== null) {
              this.searchLoad()
            }
            else {
              if (Object.keys(this.month_data).length > 0 && this.header_select !== this.LAST_YEAR + "-" + 12) {
                this.nextLoad()
              }
            }
          } else if (this.calendarSearchData === null && content.scrollTop === 0 && this.header_select !== (this.START_YEAR + 1) + "-" + 1) {
            this.prevLoad()
          }
        })
      }
    })
  },
  updated() {
    const date_content = document.querySelectorAll('.date__content')
    date_content.forEach(item => {
      this.observer.observe(item)
    })
  },
  methods: {
    initialize(group_id) {
      this.$store.commit('loading/setLoadingStatus', true)
      this.trn_group_id  = group_id
      this.resetMonthDataAll()
      const date = new Date();
      this.current_month = date.getMonth() + 1
      this.current_year = date.getFullYear()
      this.today = this.current_year + "-" + this.current_month + "-" + date.getDate()

      this.next_year = this.current_year
      this.next_month = this.current_month
      this.prev_year = this.current_year
      this.prev_month = this.current_month
      this.header_month = this.current_month
      this.header_compare_select = this.current_year - 1
      this.header_select = this.current_year + "-" + this.current_month
      this.observer = new IntersectionObserver(this.doWhenIntersect, this.observer_option)
      this.CALENDAR_DATE = getCalendarDate(this.START_YEAR, this.LAST_YEAR)
      this.calendar_data_keys = Object.keys(this.CALENDAR_DATE)
      this.calendar_data_keys.splice(0, 12)
      this.is_first = false
      this.getCalendar('next')
    },
    async getCalendar(type, callback = null) {
      let param = {
        next_data: {
          trn_group_id: this.trn_group_id,
          year: this.current_year,
          month: this.current_month,
        },
        prev_data: {
          trn_group_id: this.trn_group_id,
          year: this.current_year - this.header_compare_year_sub,
          month: this.current_month,
        }
      }
      await this.$store.dispatch('calendar/calendarGetApi', param)
      if (this.calendarApiStatus && this.calendarSearchData === null) {
        this.setCalendarData(type, this.calendarData, param.next_data.year, param.next_data.month, false, callback)
        this.setCalendarData(type, this.calendarCompareData, param.prev_data.year, param.prev_data.month, true)
      }
      else if (!this.calendarApiStatus && this.statusCode !== USER_LOGIN){
        this.initialize(this.old_group_id)
      }
    },
    setCalendarData(type, data, year, month, compare = false, callback = null) {
      // 1日の曜日
      const dayOfWeek = new Date(year, month - 1, 1).getDay()
      // 最終日
      const lastDate = new Date(year, month, 0).getDate()
      // 祝日情報
      let holidayList = getHoliday(year, month)
      // 振替休日フラグ
      let isTransferHoliday = false

      let result = []
      let result_weather = []
      let result_weather_compare = []

      for (let i = 0; i < lastDate; i++) {
        let currentDayOfWeek = (dayOfWeek + i) % 7
        let holidayFlg = 0
        // 土日祝の判定
        if (currentDayOfWeek === 6) {
          // 土曜日
          holidayFlg = 1
        } else if (currentDayOfWeek === 0) {
          // 日曜日
          holidayFlg = 2
        }
        if (holidayList.indexOf(i + 1) >= 0) {
          if (holidayFlg === 2) {
            isTransferHoliday = true
          }
          holidayFlg = 3
        } else if (isTransferHoliday) {
          // 振替休日
          holidayFlg = 4
          isTransferHoliday = false
        }

        let dayData = {
          year: year,
          month: month,
          day: i + 1,
          dayOfWeek: this.weeks[currentDayOfWeek],
          holidayFlg: holidayFlg,
          data: {
            sick_data: null,
            memo_data: null,
            post_data: null,
          }
        }

        if (!this.is_first && this.today === year + "/" + month + "/" + dayData.day) {
          dayData.today = true
        }

        if (data.calendar_data[dayData.day] !== undefined) {
          if (data.calendar_data[dayData.day].sick_data !== null) {
            dayData.data.sick_data = data.calendar_data[dayData.day].sick_data
          }
          if (data.calendar_data[dayData.day].memo_data !== null) {
            dayData.data.memo_data = data.calendar_data[dayData.day].memo_data
          }
          if (data.calendar_data[dayData.day].post_data !== null) {
            dayData.data.post_data = data.calendar_data[dayData.day].post_data
            dayData.post_other_count = data.calendar_data[dayData.day].post_other_count
          }
        }

        dayData.lastDay = lastDate === i + 1
        result[year + '-' + month + '-' + (i + 1)] = dayData

        // 天気データの追加
        let weather_data = null
        if (compare) {
          if (data.weather_data !== null && data.weather_data[dayData.day] !== undefined) {
            weather_data = data.weather_data[dayData.day]
          }
          result_weather_compare[year + '-' + month + '-' + (i + 1)] = weather_data
        } else {
          if (data.weather_data !== null && data.weather_data[i] !== undefined) {
            weather_data = data.weather_data[i]
          }
          result_weather[year + '-' + month + '-' + (i + 1)] = weather_data
        }
      }

      // データの挿入
      if (compare) {
        this.compare_month_data = type === 'next' ? {...this.compare_month_data, ...result} : {...result, ...this.compare_month_data}
        this.prev_weather_data = type === 'next' ? {...this.prev_weather_data, ...result_weather_compare} : {...result_weather_compare, ...this.prev_weather_data}
      } else {
        this.month_data = type === 'next' ? {...this.month_data, ...result} : {...result, ...this.month_data}
        if (type === 'prev') {
          this.$nextTick(() => {
            this.$refs.scroll_content.scrollTop = $('.last--day').offset().top - document.querySelectorAll('.calendar__header')[0].clientHeight
          })
        }
        this.weather_data = type === 'next' ? {...this.weather_data, ...result_weather} : {...result_weather, ...this.weather_data}
      }

      if (callback !== null) {
        callback()
      }
      if (!this.is_first) {
        this.nextLoad()
      }
    },
    async openDetailModal(id, select_type, data) {
      if (data.month === null) {
        return
      }
      $('.open').removeClass('open')
      this.modal_tab_type = select_type
      this.modal_date = data.month + "月" + data.day + "日"
      this.picture_datetime = data.year + "/" + data.month + "/" + data.day + " 00:00"
      this.update_month_data_key = data.year + "-" + data.month + "-" + data.day
      let param = {
        trn_group_id: this.trn_group_id,
        year: data.year,
        month: data.month,
        day: data.day,
      }
      await this.$store.dispatch('calendar/calendarDayGetApi', param)
      this.show(id)
    },
    openMemo(index, is_self) {
      if ($('#memo_content_' + index).hasClass('open')) {
        if (is_self) {
          $('#memo_' + index).css('display', 'none')
          $('#memo_area_' + index).css('display', 'block')
          this.$nextTick(() => {
            const textarea = $('#memo_area_' + index)
            textarea.height(textarea[0].scrollHeight + 'px')
            textarea[0].focus()
          })
        }
      } else {
        $('#memo_content_' + index).addClass('open')
      }
    },
    editSick(index, is_self) {
      if (is_self) {
        $('#sick_' + index).css('display', 'none')
        $('#sick_area_' + index).css('display', 'block')
        this.$nextTick(() => {
          const textarea = $('#sick_area_' + index)
          textarea.height(textarea[0].scrollHeight + 'px')
          textarea[0].focus()

          // 病害虫メモ欄は改行を無効化
          $('.cancel-enter').on('keydown', (e) => {
            if (e.key === 'Enter') {
              return false
            }
          })
        })
      }
    },
    editPost(index, is_self) {
      if (is_self) {
        $('#post_' + index).css('display', 'none')
        $('#post_area_' + index).css('display', 'block')
        this.$nextTick(() => {
          const textarea = $('#post_area_' + index)
          textarea.height(textarea[0].scrollHeight + 'px')
          textarea[0].focus()
        })
      }
    },
    show() {
      $("#overlay").fadeIn(200);
      $("body").css("overflow", "hidden");
      $('.memo__button--add').css('right', ($('#modalCalendarDetail').width() - $('.modal__body').width()) / 2)
      $('.memo__button--add').css('bottom', ($('#modalCalendarDetail').height() - $('.modal__body').height()) / 2 - 30)
    },
    hide() {
      $("#overlay").fadeOut(200);
      this.$store.commit('calendar/setCalendarDayData', null)
      $("body").css("overflow", "auto");
    },
    doWhenIntersect(entries) {
      if (this.calendarSearchData !== null) {
        return
      }
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.header_month = entry.target.dataset.month
          this.header_select = entry.target.dataset.year + "-" + entry.target.dataset.month
          this.header_compare_select = entry.target.dataset.year - this.header_compare_year_sub
          if (this.header_compare_select < this.START_YEAR) {
            this.header_compare_select = this.START_YEAR
          }
        }
      })
    },
    nextLoad() {
      if (this.next_month == 12) {
        this.next_month = 1
        this.next_year++
      } else {
        this.next_month++
      }
      this.current_year = this.next_year
      this.current_month = this.next_month
      let callback = null
      if (!this.is_first) {
        callback = () => {
          this.$nextTick(() => {
            this.$refs.scroll_content.scrollTop = $("#" + this.today).offset().top - ($('.calendar__header').height() + $('header').height()) + this.SCROLL_DEFAULT_POS
            this.$store.commit('loading/setLoadingStatus', false)
          })
        }
        this.is_first = true
      }
      this.getCalendar('next', callback)
    },
    prevLoad() {
      if (this.prev_month == 1) {
        this.prev_month = 12
        this.prev_year--
      } else {
        this.prev_month--
      }
      this.current_month = this.prev_month
      this.current_year = this.prev_year
      this.getCalendar('prev')
    },
    adjustHeight(id) {
      const textarea = $(id)
      const resetHeight = new Promise(function (resolve) {
        resolve(textarea.height('auto'))
      })
      resetHeight.then(function () {
        textarea.height(textarea[0].scrollHeight + 'px')
      })
    },
    addMemo() {
      let data = this.calendarDetailData
      let length = data.memo_list.length
      data.memo_list.push({
        information: "",
        is_self: 1,
        nickname: this.nickname,
        is_add_flg: 1,
      })
      this.$store.commit('calendar/setCalendarDayData', data)
      this.$nextTick(() => {
        $('#memo_content_' + length).addClass('open')
        $('.modal__body').scrollTop($('.modal__body')[0].scrollHeight)
        this.openMemo(length, true)
      })
    },
    async saveSick(index) {
      let param = {
        trn_calendar_id: this.calendarDetailData.sick_list[index].id,
        information: $('#sick_area_' + index).val(),
        mst_sick_id: this.calendarDetailData.sick_list[index].mst_sick_id,
      }
      await this.$store.dispatch('calendar/updateCalendarApi', param)
      if (this.calendarApiStatus) {
        this.calendarDetailData.sick_list[index].comment = param.information
        if (index === 0) {
          // リストの先頭ならcalendarDataの方も更新
          if (this.month_data[this.update_month_data_key] !== undefined) {
            this.month_data[this.update_month_data_key].data.sick_data.comment = param.information
          }
          if (this.compare_month_data[this.update_month_data_key] !== undefined) {
            this.compare_month_data[this.update_month_data_key].data.sick_data.comment = param.information
          }
        }
        $('#sick_' + index).css('display', 'block')
        $('#sick_area_' + index).css('display', 'none')
      }
    },
    async saveMemo(index, item) {
      if ($('#memo_area_' + index).val() === "") {
        if (item.is_add_flg) {
          this.calendarDetailData.memo_list.pop()
        }
        return
      }
      let param = {}
      if (item.is_add_flg) {
        param = {
          trn_group_id: this.trn_group_id,
          trn_calendar_id: 0,
          picture_datetime: this.picture_datetime,
          memo: $('#memo_area_' + index).val()
        }
        await this.$store.dispatch('memo/postMemoApi', param)
      }
      else {
        param = {
          trn_group_id: this.trn_group_id,
          trn_calendar_id: this.calendarDetailData.memo_list[index].id,
          picture_datetime: this.picture_datetime,
          memo: $('#memo_area_' + index).val()
        }
        await this.$store.dispatch('memo/putMemoApi', param)
      }
      if (this.memoApiStatus) {
        this.calendarDetailData.memo_list[index].information = param.memo
        if (item.is_add_flg) {
          if (this.month_data[this.update_month_data_key] !== undefined) {
            let count = 0
            if (this.month_data[this.update_month_data_key].data.memo_data !== null) {
              count = this.month_data[this.update_month_data_key].data.memo_data.count + 1
            }
            this.month_data[this.update_month_data_key].data.memo_data = {
              comment: param.memo,
              count: count
            }
          }
          if (this.compare_month_data[this.update_month_data_key] !== undefined) {
            let count = 0
            if (this.compare_month_data[this.update_month_data_key].data.memo_data !== null) {
              count = this.compare_month_data[this.update_month_data_key].data.memo_data.count + 1
            }
            this.compare_month_data[this.update_month_data_key].data.memo_data = {
              comment: param.memo,
              count: count
            }
          }
        }
        else if (index === 0) {
          // リストの先頭ならcalendarDataの方も更新
          if (this.month_data[this.update_month_data_key] !== undefined) {
            this.month_data[this.update_month_data_key].data.memo_data.comment = param.memo
          }
          if (this.compare_month_data[this.update_month_data_key] !== undefined) {
            this.compare_month_data[this.update_month_data_key].data.memo_data.comment = param.memo
          }
        }
        $('#memo_' + index).css('display', 'block')
        $('#memo_area_' + index).css('display', 'none')
      }
    },
    async savePost(index) {
      let param = {
        trn_calendar_id: this.calendarDetailData.post_list[index].id,
        information: $('#post_area_' + index).val(),
        mst_sick_id: -1,
      }
      await this.$store.dispatch('calendar/updateCalendarApi', param)
      if (this.calendarApiStatus) {
        this.calendarDetailData.post_list[index].information = param.information
        if (index === 0) {
          // リストの先頭ならcalendarDataの方も更新
          if (this.month_data[this.update_month_data_key] !== undefined) {
            this.month_data[this.update_month_data_key].data.post_data.comment = param.information
          }
          if (this.compare_month_data[this.update_month_data_key] !== undefined) {
            this.compare_month_data[this.update_month_data_key].data.post_data.comment = param.information
          }
        }
        $('#post_' + index).css('display', 'block')
        $('#post_area_' + index).css('display', 'none')
      }
    },
    async search(event) {
      // 日本語入力中のエンターは無視する
      if (event.keyCode !== 13) {
        return
      }
      if (this.search_text === "") {
        if (this.calendarSearchData !== null) {
          this.$store.commit('calendar/setCalendarSearchData', null)
          this.$nextTick(() => {
            this.$refs.scroll_content.scrollTop = this.scroll_height
          })
        }
        return
      }
      if (this.calendarSearchData === null) {
        this.scroll_height = this.$refs.scroll_content.scrollTop
      }

      this.search_param = {
        trn_group_id: this.trn_group_id,
        year: this.current_year,
        search_words: this.search_text,
      }
      this.search_prev_year = this.current_year
      await this.$store.dispatch('calendar/searchCalendarApi', this.search_param)
      if (this.calendarApiStatus) {
        if (Object.keys(this.calendarSearchData[this.search_param.year].calendar_data).length === 0) {
          navigator.notification.alert(
              '検索条件に該当するデータがありませんでした。',
              () => {
                this.search_text = ""
                this.$store.commit('calendar/setCalendarSearchData', null)
              },
              'エラー',
              'OK',
          )
        }
        else {
          this.$refs.scroll_content.scrollTop = 0
          this.search_month_data = {...this.setSearchData(this.calendarSearchData[this.search_param.year].calendar_data)}
          this.search_compare_month_data = {...this.setSearchPrevData(this.calendarSearchData[this.search_param.year - 1].calendar_data, Object.keys(this.calendarSearchData[this.search_param.year].calendar_data))}
          this.search_weather_data = {...this.calendarSearchData[this.search_param.year].weather_data}
          this.search_compare_weather_data = {...this.calendarSearchData[this.search_param.year - 1].weather_data}
        }
      }
    },
    setSearchData(data) {
      let search_data = []
      let result = []
      Object.keys(data).forEach(item => {
        // 1日の曜日
        const dayOfWeek = new Date(data[item].year, data[item].month - 1, 1).getDay()
        // 祝日情報
        let holidayList = getHoliday(data[item].year, data[item].month)
        // 振替休日フラグ
        let isTransferHoliday = false
        let currentDayOfWeek = (dayOfWeek + (data[item].day - 1)) % 7
        let holidayFlg = 0
        // 土日祝の判定
        if (currentDayOfWeek === 6) {
          // 土曜日
          holidayFlg = 1
        } else if (currentDayOfWeek === 0) {
          // 日曜日
          holidayFlg = 2
        }
        if (holidayList.indexOf(data[item].day + 1) >= 0) {
          if (holidayFlg === 2) {
          }
          holidayFlg = 3
        } else if (isTransferHoliday) {
          // 振替休日
          holidayFlg = 4
        }
        let dayData = {
          year: data[item].year,
          month: data[item].month,
          day: data[item].day,
          dayOfWeek: this.weeks[currentDayOfWeek],
          holidayFlg: holidayFlg,
          data: {
            sick_data: data[item].sick_data,
            memo_data: data[item].memo_data,
            post_data: data[item].post_data,
          },
          post_other_count: data[item].post_other_count
        }
        if (search_data[dayData.year + "-" + dayData.month] === undefined) {
          search_data[dayData.year + "-" + dayData.month] = [dayData]
        } else {
          search_data[dayData.year + "-" + dayData.month].push(dayData)
        }
      })
      let keys = Object.keys(search_data)
      keys.sort((a, b) => {
        let a_split = a.split('-')
        let b_split = b.split('-')
        let a_yy = a_split[0]
        let a_mm = a_split[1].length === 1 ? "0" + a_split[1] : a_split[1]
        let b_yy = b_split[0]
        let b_mm = b_split[1].length === 1 ? "0" + b_split[1] : b_split[1]
        return a_yy + "/" + a_mm < b_yy + "/" + b_mm ? 1 : -1
      })
      keys.forEach(key => {
        search_data[key].sort((a, b) => {
          return parseInt(a.day) > parseInt(b.day) ? 1 : -1
        })
        result[key] = search_data[key]
      })
      return result
    },
    setSearchPrevData(data, key_list) {
      let search_data = []
      let result = []
      let data_keys = []
      Object.keys(data).forEach(item => {
        data_keys.push(item.split('-')[1] + "-" + item.split('-')[2])
      })
      key_list.filter(index => {
        if (data_keys.indexOf(index.split('-')[1] + "-" + index.split('-')[2]) !== -1) {
          let prev_data = data[this.search_param.year - 1 + "-" + data_keys[data_keys.indexOf(index.split('-')[1] + "-" + index.split('-')[2])]]
          const dayOfWeek = new Date(prev_data.year, prev_data.month - 1, 1).getDay()
          let holidayList = getHoliday(prev_data.year, prev_data.month)
          let isTransferHoliday = false
          let currentDayOfWeek = (dayOfWeek + (prev_data.day - 1)) % 7
          let holidayFlg = 0
          if (currentDayOfWeek === 6) {
            holidayFlg = 1
          } else if (currentDayOfWeek === 0) {
            holidayFlg = 2
          }
          if (holidayList.indexOf(prev_data.day + 1) >= 0) {
            if (holidayFlg === 2) {
            }
            holidayFlg = 3
          } else if (isTransferHoliday) {
            holidayFlg = 4
          }
          let dayData = {
            year: prev_data.year,
            month: prev_data.month,
            day: prev_data.day,
            dayOfWeek: this.weeks[currentDayOfWeek],
            holidayFlg: holidayFlg,
            data: {
              sick_data: prev_data.sick_data,
              memo_data: prev_data.memo_data,
              post_data: prev_data.post_data,
            },
            post_other_count: prev_data.post_other_count
          }
          if (search_data[dayData.year + "-" + dayData.month] === undefined) {
            search_data[dayData.year + "-" + dayData.month] = [dayData]
          } else {
            search_data[dayData.year + "-" + dayData.month].push(dayData)
          }
        }
        else {
          let yy = index.split('-')[0] - 1
          let mm = index.split('-')[1]
          let dd = Number(index.split('-')[2])
          const dayOfWeek = new Date(yy, mm - 1, 1).getDay()
          let holidayList = getHoliday(yy, mm)
          let isTransferHoliday = false
          let currentDayOfWeek = (dayOfWeek + (dd - 1)) % 7
          let holidayFlg = 0
          if (currentDayOfWeek === 6) {
            holidayFlg = 1
          } else if (currentDayOfWeek === 0) {
            holidayFlg = 2
          }
          if (holidayList.indexOf(dd + 1) >= 0) {
            if (holidayFlg === 2) {
            }
            holidayFlg = 3
          } else if (isTransferHoliday) {
            holidayFlg = 4
          }
          let dayData = {
            year: yy,
            month: mm,
            day: dd,
            dayOfWeek: this.weeks[currentDayOfWeek],
            holidayFlg: holidayFlg,
            data: {
              sick_data: null,
              memo_data: null,
              post_data: null,
            }
          }
          if (search_data[(parseInt(index.split('-')[0]) - 1) + "-" + parseInt(index.split('-')[1])] === undefined) {
            search_data[(parseInt(index.split('-')[0]) - 1) + "-" + parseInt(index.split('-')[1])] = [dayData]
          } else {
            search_data[(parseInt(index.split('-')[0]) - 1) + "-" + parseInt(index.split('-')[1])].push(dayData)
          }
        }
      })
      let keys = Object.keys(search_data)
      keys.sort((a, b) => {
        let a_split = a.split('-')
        let b_split = b.split('-')
        let a_yy = a_split[0]
        let a_mm = a_split[1].length === 1 ? "0" + a_split[1] : a_split[1]
        let b_yy = b_split[0]
        let b_mm = b_split[1].length === 1 ? "0" + b_split[1] : b_split[1]
        return a_yy + "/" + a_mm < b_yy + "/" + b_mm ? 1 : -1
      })
      keys.forEach(key => {
        search_data[key].sort((a, b) => {
          return parseInt(a.day) > parseInt(b.day) ? 1 : -1
        })
        result[key] = search_data[key]
      })
      return result
    },
    async searchLoad() {
      this.search_prev_year--
      this.search_param.year = this.search_prev_year

      await this.$store.dispatch('calendar/searchCalendarApi', this.search_param)
      if (this.calendarApiStatus) {
        this.search_month_data = {...this.search_month_data, ...this.setSearchData(this.calendarSearchData[this.search_param.year].calendar_data)}
        this.search_compare_month_data = {...this.search_compare_month_data, ...this.setSearchPrevData(this.calendarSearchData[this.search_param.year - 1].calendar_data, Object.keys(this.calendarSearchData[this.search_param.year].calendar_data))}
      }
    },
    getSelectCalendar() {
      this.resetMonthDataAll()
      this.current_year = this.header_select.split('-')[0]
      this.current_month = this.header_select.split('-')[1]

      this.next_year = this.current_year
      this.next_month = this.current_month
      this.prev_year = this.current_year
      this.prev_month = this.current_month
      this.header_month = this.current_month
      this.header_compare_select = this.current_year - this.header_compare_year_sub
      this.getCalendar('next', () => {
        this.$nextTick(() => {
          this.$refs.scroll_content.scrollTop = this.SCROLL_DEFAULT_POS
        })
      })
    },
    changeCompareSub(value) {
      this.header_compare_year_sub = this.current_year - value
      this.getSelectCalendar()
    },
    resetMonthDataAll() {
      this.month_data = {...[]}
      this.compare_month_data = {...[]}
      this.weather_data = {...[]}
      this.prev_weather_data = {...[]}
    },
    logout() {
      navigator.notification.confirm(
          'ログアウトしますがよろしいですか。',
          this.logoutCallback,
          '',
          ['OK', 'キャンセル']);
    },
    async logoutCallback(id) {
      if(id === 1) {
        await this.$store.dispatch('authorize/logoutApi')
        NativeStorage.remove("profile", () => { this.$router.push('/') }, null);
      }
    },
    async getGroup() {
      await this.$store.dispatch('group/groupApi')
    },
    toggleSetting() {
      $('.setting').toggleClass("active");
      $('.setting__background').css('display', 'block')
    },
    closeSetting() {
      $('.setting').removeClass("active");
      $('.setting__background').css('display', 'none')
    },
  },
  computed: {
    ...mapState({
      groupData: state => state.group.groupData,
      groupId: state => state.group.groupId,
      calendarApiStatus: state => state.calendar.apiStatus,
      calendarData: state => state.calendar.calendarData,
      calendarCompareData: state => state.calendar.calendarCompareData,
      calendarDetailData: state => state.calendar.calendarDayData,
      calendarSearchData: state => state.calendar.calendarSearchData,
      memoApiStatus: state => state.memo.apiStatus,
      statusCode: state => state.error.statusCode,
    })
  },
  watch: {
    trn_group_id(value, old_value) {
      if (this.is_first) {
        this.initialize(value)
        this.old_group_id = old_value
      }
    },
    modal_tab_type(value) {
      if (value === this.TAB_TYPE.memo) {
        this.$nextTick(() => {
          $('.memo__button--add').css('right', ($('#modalCalendarDetail').width() - $('.modal__body').width()) / 2)
          $('.memo__button--add').css('bottom', ($('#modalCalendarDetail').height() - $('.modal__body').height()) / 2 - 30)
        })
      }
    }
  },
}
</script>
